"use strict";

import onInitModulesInsScope from "./onInitModulesInScope";

/**
 * WAI-ARIA Tabs keyboard pattern (roving tabindex + arrow-key navigation)
 * for the Fahrtrichtung tablist. Bootstrap's data-toggle="tab" only wires up
 * click activation — once role="tablist"/role="tab" is used, arrow-key
 * movement between tabs (with Home/End) is expected too.
 */

function focusTab(tabs, index) {
    let tab = tabs[(index + tabs.length) % tabs.length];
    tabs.forEach(function (t) {
        t.tabIndex = (t === tab) ? 0 : -1;
    });
    tab.focus();
    $(tab).tab('show');
}

export function init() {
    onInitModulesInsScope(function initInScope($scope) {
        $scope.find('.content-timetable__tabs').each(function () {
            let tabs = $(this).find('.content-timetable__tab').toArray();

            $(this).on('keydown', '.content-timetable__tab', function (e) {
                let index = tabs.indexOf(this);
                if (index === -1) {
                    return;
                }

                switch (e.key) {
                    case 'ArrowRight':
                    case 'ArrowDown':
                        e.preventDefault();
                        focusTab(tabs, index + 1);
                        break;
                    case 'ArrowLeft':
                    case 'ArrowUp':
                        e.preventDefault();
                        focusTab(tabs, index - 1);
                        break;
                    case 'Home':
                        e.preventDefault();
                        focusTab(tabs, 0);
                        break;
                    case 'End':
                        e.preventDefault();
                        focusTab(tabs, tabs.length - 1);
                        break;
                }
            });
        });
    });
}
